import { redirect } from "@tanstack/react-router";

import { getAuth } from "@/lib/auth-storage";

/** Protect dashboard routes. Client-only because auth lives in localStorage. */
export function requireAuth() {
  if (typeof window === "undefined") return;
  if (!getAuth()?.token) {
    throw redirect({ to: "/signin", replace: true });
  }
}

/** Customer KYC form. Admins never see it, and a finished form is not shown again. */
export function requireOnboarding() {
  if (typeof window === "undefined") return;
  const auth = getAuth();
  if (!auth?.token) throw redirect({ to: "/signin", replace: true });
  if (auth.user.role === "ADMIN") throw redirect({ to: "/admin", replace: true });
  if (auth.user.kycSubmitted) throw redirect({ to: "/dashboard", replace: true });
}
